module.exports = __webpack_public_path__ + "img/floor1_1.8bbfbbe0.jpg";